export default [
    {
        path: '/eixos',
        view: 'eixos/Index',
        name: 'Listagem de Eixos',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Eixos',
                disabled: true,
                exact: true,
                to: '/eixos',
            },
        ],
    },
    {
        path: '/eixos/novo',
        view: 'eixos/New',
        name: 'Cadastro de Eixo',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Eixos',
                disabled: false,
                exact: true,
                to: '/eixos',
            },
            {
                text: 'Novo',
                disabled: true,
                exact: true,
                to: '/eixos/novo',
            }
        ],
    },
    {
        path: '/eixos/editar/:id',
        view: 'eixos/Edit',
        name: 'Edição de Eixo',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Eixos',
                disabled: false,
                exact: true,
                to: '/eixos',
            },
            {
                text: 'Editar',
                disabled: true,
                exact: true,
                to: '/eixos/editar/:id',
            }
        ],
    },
    {
        path: '/eixos/ordenarEixos/:eixoSuperiorId?',
        view: 'eixos/Ordenacao',
        name: 'Ordenação de Eixos',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Eixos',
                disabled: false,
                exact: true,
                to: '/eixos',
            },
            {
                text: 'Ordenação',
                disabled: true,
                exact: true,
                to: '/eixos/ordenarEixos/:paiId',
            }
        ],
    },
    {
        path: '/eixos/excluir',
        permissions: ['ADMINISTRADOR', 'GESTOR']
    },
    {
        path: '/eixos/ativarInativar',
        permissions: ['ADMINISTRADOR', 'GESTOR']
    }
];
